<div>
  <div>
    <div *ngIf="complemento?.explicacao" class="input-explicacao">
      <mat-icon class="not-clickable">error_outline</mat-icon>
      <p>{{ complemento?.explicacao }}</p>
    </div>

    <div class="input-row">
      <app-arquivo-upload
        name="fileInput"
        [autoUpload]="true"
        [fc]="formControl"
        accept="application/pdf"
        uploadPath="{{ 'inscricaocomplemento/' + complemento?.idConcurso }}"
        [usarArquivoViewer]="true"
        [viewerTitle]="complemento?.grupo || complemento?.explicacao || 'Documento complementar'"
        [idInscricao]="idInscricao"
        [complementoId]="complemento?.id"
        [idConcurso]="complemento?.idConcurso?.toString()"
        [codigoOrgao]="codigoOrgao"
        label="{{ complemento?.requerido ? '(Obrigatório)' : '(Opcional)' }}"></app-arquivo-upload>
    </div>
  </div>
</div>
